module.exports = __webpack_public_path__ + "a937238b6395c17d81910abb43ab50b0.svg";